import { AxiosResponse } from "axios";
import { PaginationV2 } from "@/domain/entities/Pagination";
import {
  Customer,
  CustomerCommodity,
  CustomerListEntities,
  CustomerSavedPackage,
  CustomerSavedPackageDetail,
  CustomerSavedPackagePiece
} from "@/domain/entities/Customer";
import {
  ResponsePayload
} from "@/domain/entities/ResponsePayload";

export class CustomerMapper {
  public convertListDataFromApi(res: AxiosResponse): CustomerListEntities {
    const { data } = res;

    return new CustomerListEntities({
      pagination: new PaginationV2({
        page: data.meta.page,
        limit: data.meta.limit,
        totalData: data.meta.total_records
      }),
      data: data.data?.length
        ? data.data.map(
          (key: any) =>
            new Customer({
                customerId: key.customer_id,
                customerName: key.customer_name,
                customerPhoneNumber: key.customer_phone_number,
                customerAddress: key.customer_address,
                customerAccountType: key.customer_account_type,
                customerRefId: key.customer_ref_id,
                customerDistrictId: key.customer_district_id,
                customerDistrictName: key.customer_district_name,
                customerZipCode: key.customer_zip_code,
                customerAddressType: key.customer_address_type,
                customerCreatedBy: key.customer_created_by,
                customerUpdatedBy: key.customer_updated_by,
                customerCreatedAt: key.customer_created_at,
                customerUpdatedAt: key.customer_updated_at,
                customerEmail: key.customer_email,
                customerNote: key.customer_note,
                customerCommodity: key.customer_commodity,
            })
        )
        : []
    });
  }

  public convertChangeDataFromApi(result: AxiosResponse<any>): ResponsePayload {
    const { data } = result;
    return new ResponsePayload({
      success: data.success,
      message: data.message
    });
  }

  public convertSavedPackageListFromApi(
    result: AxiosResponse<any>
  ): CustomerSavedPackage[] {
    const { data } = result;
    const dataList = data?.data ?? data ?? [];
    return (dataList || []).map((item: any) => {
      return new CustomerSavedPackage({
        id: item.csp_id,
        commodityCode: item.csp_commodity_code,
        totalPieces: item.csp_total_piece,
        totalGrossWeight: item.csp_total_gross_weight,
        source: item.csp_source,
        commodityName: item.commodity_name,
        isDangerousGoods: item.is_dangerous_goods,
        isQuarantine: item.is_quarantine
      });
    });
  }

  public convertSavedPackageDetailFromApi(
    result: AxiosResponse<any>
  ): CustomerSavedPackageDetail {
    const { data } = result;
    const detail = data?.data ?? data ?? {};
    const pieces = detail.pieces ?? [];
    return new CustomerSavedPackageDetail({
      id: detail.csp_id ?? detail.id,
      commodityCode: detail.csp_commodity_code ?? detail.commodity_code,
      pieces: (pieces || []).map(
        (piece: any) =>
          new CustomerSavedPackagePiece({
            grossWeight: piece.cspp_gross_weight,
            length: piece.cspp_length,
            width: piece.cspp_width,
            height: piece.cspp_height
          })
      )
    });
  }

  public convertDetailProductDataFromApi(
    result: AxiosResponse<any>
  ): Customer {
    const { data } = result.data;
    return new Customer({
      customerId: data.customer_id,
      customerName: data.customer_name,
      customerPhoneNumber: data.customer_phone_number,
      customerAddress: data.customer_address,
      customerAccountType: data.customer_account_type,
      customerRefId: data.customer_ref_id,
      customerDistrictId: data.customer_district_id,
      customerDistrictName: data.customer_district_name,
      customerZipCode: data.customer_zip_code,
      customerAddressType: data.customer_address_type,
      customerCreatedBy: data.customer_created_by,
      customerUpdatedBy: data.customer_updated_by,
      customerCreatedAt: data.customer_created_at,
      customerUpdatedAt: data.customer_updated_at,
      customerEmail: data.customer_email,
      customerNote: data.customer_note,
      customerCommodity: new CustomerCommodity({
        code: data.customer_commodity?.commodity_code,
        name: data.customer_commodity?.commodity_name,
        status: data.customer_commodity?.status,
        isDangerousGoods: data.customer_commodity?.is_dangerous_goods,
        isQuarantine: data.customer_commodity?.is_quarantine,
      })
    });
  }
}